<div class="pages">
  <div data-page="blog" class="page no-toolbar no-navbar">
    <div class="page-content">

      <div class="navbarpages">
        <div class="navbar_left"><a [routerLink]="['/menu']"><img src="./assets/images/icons/blue/menu.png"
          alt=""
        title=""/></a></div>
        <div class="navbar_center"><h2>{{ this.Ueberschrift }}</h2></div>

      </div>
      <div id="pages_maincontent">
        <h2 class="page_title">Position vom Fahrzeug - Stand von {{ this.aktualisierung }}</h2>


        <google-map
          height="500px"
          width="90%"
          [center]="center"
          >
          <map-marker
            [position]="marker_fzg.position"
            [label]="marker_fzg.label"
            [title]="marker_fzg.title"
            [options]="marker_fzg.options"
          ></map-marker>


        </google-map>
        <div><br>

          <h1>Zentrieren auf:</h1>
          <select [(ngModel)]="selectedfzg" (change)="changefahrzeug();" class="form-select" data-live-search="true">
            <!--<option selected>Open this select menu</option>-->
            <!--<optgroup label="Picnic">-->
            @for (f of this.fahrzeuge; track f) {
              <option [selected]="selectedfzg == f.id" value="{{f.id}}">{{f.bezeichnung}} - {{f.funkrufname}}</option>
            }

          <!-- </optgroup>-->
        </select>



      </div>
    </div>
  </div>
</div>
